module.exports = __webpack_public_path__ + "files/0eb5ea4bcdc187f230ff400f021fb3c6.svg";